import { GridComparatorFn, GridSortCellParams } from "@mui/x-data-grid-pro";
import moment from "moment";
import { IStaffDto } from "../dto/app-init.dto";

export const dateComparator: GridComparatorFn<Date> = (v1, v2) =>
  moment(v1).isSameOrBefore(moment.utc(v2)) ? -1 : 1;

export const staffComparator = (
  v1: string,
  v2: string,
  cp1: GridSortCellParams<string>,
  cp2: GridSortCellParams<string>,
  staffList: IStaffDto[]
) => {
  const staff1Initials = staffList.find((s) => s.__id === v1)?.initials || "";
  const staff2Initials = staffList.find((s) => s.__id === v2)?.initials || "";

  return staff1Initials < staff2Initials ? -1 : 1;
};

export const getTooltip = (value: string, maxWidth: number) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  let labelWidth = 0;
  if (context) {
    context.font = getComputedStyle(document.body).font;
    labelWidth = context.measureText(value || "").width;
  }
  return (labelWidth || 0) > (maxWidth || 0) ? value : undefined;
};
